module.exports = __webpack_public_path__ + "70bfeeb57a818a45c22c650c771678a4.pdf";